import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(utc)
dayjs.extend(localizedFormat)

export function formatDateTimeDisplay(dateString?: string | null) {
  if (!dateString) return ''

  return dayjs.utc(dateString).local().format('D MMM YYYY, h:mm A')
}

export const formatDateDisplay = (dateString?: string | null) => {
  if (!dateString) return ''

  return dayjs.utc(dateString).local().format('DD/MM/YYYY')
}

export const formatMonthDisplay = (monthString?: string | null) => {
  if (!monthString) return { monthName: '', firstDay: '', lastDay: '', dateRange: '' }

  const date = dayjs(monthString)
  const monthName = date.format('MMMM YYYY')
  const firstDay = date.startOf('month').format('DD/MM/YYYY')
  const lastDay = date.endOf('month').format('DD/MM/YYYY')
  const dateRange = `${firstDay} - ${lastDay}`

  return {
    monthName,
    firstDay,
    lastDay,
    dateRange
  }
}
